import {
  Box,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { SavePlanSetPlansForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import React from 'react';
import { useParams } from 'react-router-dom';



export type CreateManyPlansModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: CreateManyPlansModalProps) => {
  const params = useParams();
  const theme = useTheme();

  return (
    <BasicFormModalLayout.FC
      {...props}
      title='Add Plans'
      subTitle='Add plans to this plan set'
      headerIcon={(
        <CustomIcon.large.FC
          stroke={theme.palette.primary.main}
          icon='PLAN'
        />
      )}
    >
      <Box
        height='inherit'
      >
        <SavePlanSetPlansForm.FC
          planSetId={params.planSetId ?? ''}
          projectId={params.projectId ?? ''}
          handleClose={props.handleClose}
        />
      </Box>
    </BasicFormModalLayout.FC>
  );
};
